
import { mastheads_local, mastheads_dev, mastheads_sit, mastheads_uat, mastheads_prod } from './mastheads';

const registrationConfig = {
  enabled: true, // global enabled
  environment: {
    local: {
      enabled: true,
      sites: mastheads_local,
      domainSuffix: 'sit',
      caasDomain: 'https://subscriptions.'
    },
    dev: {
      enabled: true,
      sites: mastheads_dev,
      domainSuffix: 'sit',
      caasDomain: 'https://subscriptions.',
    },
    sit: {
      enabled: true,
      domainSuffix: 'sit',
      sites: mastheads_sit,
      caasDomain: 'https://subscriptions.',
    },
    uat: {
      enabled: true,
      domainSuffix: 'uat',
      sites: mastheads_uat,
      caasDomain: 'https://subscriptions.',
    },
    prod: {
      enabled: true,
      domainSuffix: '',
      sites: mastheads_prod,
      caasDomain: 'https://subscriptions.',
    }
  },
  resourcePaths: {
    caas: '.com.au/loader/loader.js',
    rampart: '/remote/identity/rampart/latest/rampart.js'
  },
  strategy: {
    default: 'onload'
  }

};

export default registrationConfig;
